<template>
  <v-snackbar
    v-model="isVisible"
    left
    vertical
    :timeout="10000"
    :color="importSnackbarColor(ir)"
  >
    <v-row dense justify="center" align="center" style="min-width: 350px">
      <v-col cols="8">
        <div>
          {{ ir.totalEmployeesAfter - ir.totalEmployeesBefore }}
          {{ $t("import.notification.newEmployees") }}
        </div>
        <div>
          {{ Math.abs(ir.activeEmployeesBefore - ir.activeEmployeesAfter) }}
          {{
            ir.activeEmployeesAfter - ir.activeEmployeesBefore >= 0
              ? $t("import.notification.employeesActivated")
              : $t("import.notification.employeesDeactivated")
          }}
        </div>
        <template v-if="ir.maxActiveEmployees < ir.activeEmployeesAfter">
          <div>{{ $t("import.notification.notification") }}</div>
        </template>
      </v-col>
      <v-col class="pa-0 text-center">
        <v-btn
          text
          class="ma-0"
          @click="
            () => {
              $router.push('/reports');
              $emit('close-notification');
            }
          "
          >{{ $t("import.notification.showLog") }}</v-btn
        >
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script>
export default {
  props: ["show", "ir"],

  computed: {
    isVisible: {
      get() {
        return this.show;
      },
      set(newVal) {
        return newVal;
      },
    },
  },
  methods: {
    importSnackbarColor(r) {
      if (
        !r.maxActiveEmployees ||
        r.maxActiveEmployees > r.activeEmployeesAfter
      ) {
        return "success";
      } else return "warning";
    },
  },
};
</script>